const hasKey = obj => key => !!(obj && obj[key]);
const hasEnv = key => !!(hasKey(process)('env') && process.env[key]);

const findValue = (value, obj, fn) => {
  if (fn(value)) return obj[value];

  if (fn(`GATSBY_${value}`)) return obj[`GATSBY_${value}`];

  return null;
};

export default function getEnvironmentValue(base, value) {
  const envValue = findValue(value, process.env, hasEnv);
  if (envValue) return envValue;

  const windowValue = findValue(value, window, hasKey(window));
  if (windowValue) return windowValue;

  return base;
}



// WEBPACK FOOTER //
// ../src/templates/MainNav/utils/getEnvironmentValue.js